import type { Directive, App } from 'vue'
import { VClosePopper } from 'floating-vue'
import exerciseState from './exercise-state'
import groupDirective from './group-directive'
import openMemberSideBar from './open-member-side-bar'
import shadowDom from './shadow-dom'

const directives = {
  exerciseState,
  openMemberSideBar,
  shadowDom,
  ...groupDirective,
  'close-popper': VClosePopper as Directive,
}

export default {
  install(app: App) {
    for (const directive in directives) {
      app.directive(directive, directives[directive as keyof typeof directives])
    }
  },
}
